// ----------------------------------------------------------------------------
// Template: Order
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/page-hero/page-hero';

// Styles
import './_order.scss';